import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { QrCode } from "lucide-react";
import api from "@/lib/api";

export default function SuspendedPage() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get("/public/settings").then((res) => setSettings(res.data || {})).catch(() => {});
  }, []);

  const suspensionMessage = settings.suspension_message || "This Smart-QR profile is currently unavailable.\nThe owner's subscription may have lapsed.";
  const platformName = settings.platform_name || "Smart-QR";

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="text-center max-w-md animate-fade-in" data-testid="suspended-page">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-secondary mb-6">
          <QrCode className="text-muted-foreground" size={32} />
        </div>
        <h1 className="font-heading text-2xl font-bold mb-3">
          Profile Unavailable
        </h1>
        <p className="text-muted-foreground mb-8 leading-relaxed whitespace-pre-line" data-testid="suspension-message">
          {suspensionMessage}
        </p>
        <Link to="/signup">
          <Button className="btn-glow px-6" data-testid="suspended-cta-btn">
            {`Create Your Own ${platformName}`}
          </Button>
        </Link>
        <p className="text-xs text-muted-foreground mt-6" data-testid="suspended-footer">
          {platformName} &mdash; Dynamic QR Codes for the Modern Web
        </p>
      </div>
    </div>
  );
}
